<div class="pt-4 pb-4">
  <div
    class="container-fluid ps-4 pe-4"
    *ngFor="let key of TRANSLATION_KEYS; let i = index"
    [attr.data-test-id]="'main-information-' + (i + 1)"
    [innerHtml]="key | translate: { privacyPolicyLink: LINK_TERMS }"
  ></div>
</div>
